var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Upload',_vm._b({ref:"upload",staticClass:"upload-style",attrs:{"action":_vm.uploadUrl,"headers":_vm.headers}},'Upload',_vm.$attrs,false),[_c('Button',[_vm._v("上传")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }